  if (!customElements.get('td-freeswatch-popup')) {
  class TdFreeswatchPopup extends HTMLElement {
    constructor() {
      super();
      this.popupTriggers = this.querySelectorAll('.open_modal_fabric');
    }

    connectedCallback() {
      this.popupTriggers.forEach(trigger => {
        trigger.addEventListener('click', (e) => {
          e.preventDefault();
          this.openPopup(trigger);
        });
      });

      this.querySelectorAll('.td-popup-atb').forEach(btn => {
        btn.addEventListener('click', (event) => {
          const checkboxId = btn.getAttribute('data-id');
          if (checkboxId) {
            const checkbox = document.getElementById(checkboxId);
            if (checkbox && checkbox.type === 'checkbox' && !checkbox.checked) {
              checkbox.checked = true;
              checkbox.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
          this.closePopup(btn);
        });
      });

      this.querySelectorAll('input[type="checkbox"]').forEach(checkbox => {
        checkbox.addEventListener('change', (e) => {
          this.updateActiveState(e.target);
        });
      });
    }

    openPopup(trigger) {
      const popupId = trigger.getAttribute('href');
      const modal = Array.from(this.querySelectorAll('td-modal')).find(tdModal => {
        const modalContent = tdModal.querySelector('.materialModal');
        return modalContent && ('#' + modalContent.id) === popupId;
      });
      if (modal && typeof modal.openModal === 'function') {
        modal.openModal();
      }
    }

    closePopup(element) {
      const modal = element.closest('td-modal');
      if (modal && typeof modal.closeModal === 'function') {
        modal.closeModal();
      }
    }

    updateActiveState(checkbox) {
      const fabricBlock = checkbox.closest('.freeswatch-fabric-block');
      if (fabricBlock) {
        if (checkbox.checked) {
          fabricBlock.classList.add('td-fabric-active');
        } else {
          fabricBlock.classList.remove('td-fabric-active');
        }
      }
    }
  }

  customElements.define('td-freeswatch-popup', TdFreeswatchPopup);
}
